import React from "react";
import { Route, RouteProps, Redirect, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import LoadingScreen from "../LoadingScreen";

export interface ProtectedRouteProps extends RouteProps {
  redirectPath?: string;
  privileges?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  redirectPath = "/signin",
  privileges,
  ...props 
}) => {
  const location = useLocation(); // Get full location with query params
  const { status, roles } = useAuth();

  // Extract only the relative path (avoid absolute URLs)
  const redirectTo = encodeURIComponent(
    `${location.pathname}${location.search}`
  );

  if (status === "loading") {
    return <LoadingScreen />;
  }

  if (status === "anonymous") {
    return <Redirect to={`${redirectPath}?redirect=${redirectTo}`} />;
  }

  if (privileges && !roles.some((role) => privileges.includes(role))) {
    return <Redirect to={`${redirectPath}?redirect=${redirectTo}`} />;
  }
 
  return <Route {...props} />;
};

export default ProtectedRoute;
